/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
export default {
	TAB: 'TAB',
	ENTER: 'ENTER',
	ESCAPE: 'ESCAPE',
	SPACE: 'SPACE',
	LEFT: 'LEFT',
	UP: 'UP',
	RIGHT: 'RIGHT',
	DOWN: 'DOWN',
	BACKSPACE: 'BACKSPACE',
	F10: 'F10',
	A: 'A',
	HOME: 'HOME',
	END: 'END',
	NOT_RECOGNIZED: 'not recognized',
};
